import { FC } from 'react';
import Reviews from '@components/Reviews';
import { useProjectsReviewsLogic } from './hooks/useProjectsReviewsLogic';
import { useProjectsReviewsConfig } from './hooks/useProjectsReviewsConfig';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '@components/ErrorFallback';

type ProjectsReviewsProps = {
  isMobileView: boolean;
  onPageChange: () => void;
};

const ProjectsReviews: FC<ProjectsReviewsProps> = ({
  isMobileView,
  onPageChange,
}) => {
  const logic = useProjectsReviewsLogic();

  // Extract all configuration
  const { contentProps, pagingProps } = useProjectsReviewsConfig({
    ...logic,
    isMobileView,
    onPageChange,
  });

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Reviews
        paginationMode="paging"
        pagingProps={pagingProps}
        content={contentProps}
      />
    </ErrorBoundary>
  );
};

export default ProjectsReviews;
